<template lang="pug">
.container.col-centered
  .row
    .col-md-8.col-md-offset-2
      .panel.panel-default(style="background: #f8f9fa; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.03);")
        .panel-heading(style="padding: 24px 24px 8px 24px;")
          h2.main_title.mt-0.mb-1 MT Download
          p.text-muted.mb-0 Download the latest MT Bootloader and Firmware for OS2 Pro and OS5 models.
        .panel-body(style="padding: 24px;")
          .form-group.col-12.mb-3
            label.control_label.col-12 Category:
            v-select.col-12(v-bind:value.sync='selectedCategory' v-bind:options='categoryOptions' @change="onCategoryChange" style="width: 100%; min-width: 180px;")
          .form-group.col-12.mb-3
            label.control_label Model:
            v-select(v-bind:value.sync='selectedModel' v-bind:options='modelOptions' @change="onModelChange" search placeholder='Search or select model...' style="width: 100%; min-width: 180px;")
          .form-group.col-12.mb-3
            label.control_label MT Bootloader:
            v-select(v-bind:value.sync='selectedBootloader' v-bind:options='bootloaderOptions' :disabled='bootloaderOptions.length === 0' placeholder='Not Selected' style="width: 100%; min-width: 180px;")
            button.btn.btn-primary.btn-block.mt-2(v-if="selectedBootloader" @click="downloadBootloader" :disabled="!selectedBootloader" style="width: 100%;")
              span.glyphicon.glyphicon-cloud-download
              span.ml-2 Download Bootloader
          .form-group.col-12.mb-3
            label.control_label MT Firmware:
            v-select(v-bind:value.sync='selectedFirmware' v-bind:options='firmwareOptions' :disabled='firmwareOptions.length === 0' placeholder='Not Selected' style="width: 100%; min-width: 180px;")
            button.btn.btn-primary.btn-block.mt-2(v-if="selectedFirmware" @click="downloadFirmware" :disabled="!selectedFirmware" style="width: 100%;")
              span.glyphicon.glyphicon-cloud-download
              span.ml-2 Download Firmware
      .row
        .col-md-12
          spinner(v-ref:spinner size="md" show="false" text="Loading...")
          .alert.alert-info.mt-3
            strong Notice:
            |  If you cannot find your model directly in the list, it means this model is not yet supported for porting. Please contact support to request porting for your model, or try different category/model combinations to see available firmware.
</template>

<script>
import { select, spinner } from 'vue-strap'
import { getCustomForUI, getIconSrc, getDb } from '../../index.js'
import _ from 'lodash'

// Static data for OS5 MT bootloader and OS2 Pro MT bootloader
const staticBootloaderData = [
  // --- OS5 MT Bootloader ---
  {
    version: "V5.0.1",
    date: "2025/03/12 19:12:00",
    description: "Support Booting from a Board that does not Have a Burned CPU Key.",
    md5: "dcc4a46b6d0a271617dc65c30f7300b0",
    url: "https://drive.google.com/uc?export=download&id=1y0a-cjf7-Fqwm11ofVA61XSoZ-JC3iZW",
    category: "os5",
    modelTxt: "OS5 MT Bootloader",
    modelKey: "os5_mt_bootloader"
  },
  {
    version: "V5.0.0",
    date: "2025/01/22 13:59:52",
    description: "Compliance with the OS5 MT Mode Specification V1.1",
    md5: "6c7eff1146a849bce4180c83034698b9",
    url: "https://drive.google.com/uc?export=download&id=1xRp8kNh7_sN2E5FnL-2YghgneeceZdAN",
    category: "os5",
    modelTxt: "OS5 MT Bootloader",
    modelKey: "os5_mt_bootloader"
  },
  {
    version: "V5.0.0_d01",
    date: "2024/12/25 12:50:22",
    description: "Modify command mtest for memory test, mmc for eMMC test, sf for SPI flash test, version to show MT-Bootloader version, remove Factory Mode key auto burnning process during login FT mode, add command efuse for burn efuse, add lt password.",
    md5: "BA73667B1B0724B40B9F2145B96AA56A",
    url: "https://drive.google.com/file/d/1ezEjqh6ll2PXwbWjLsfeR32gdUPHTKlG/view?usp=drive_link",
    category: "os5",
    modelTxt: "OS5 MT Bootloader",
    modelKey: "os5_mt_bootloader"
  },
  // --- OS2 Pro MT Bootloader ---
  {
    version: "V6.0.6",
    date: "2024-12-26 14:23:21",
    description: "Burn Secure Boot Key: Require instaMark V1.7.1. Internal Improvements.",
    md5: "e18ec208aa590e07962284e4fe36992f",
    url: "https://drive.google.com/uc?export=download&id=1HfwJ_JM31QZOOttk8jC0R07bosqdJIhW",
    category: "os2_plus",
    modelTxt: "OS2 Pro MT Bootloader",
    modelKey: "os2_pro_mt_bootloader"
  },
  {
    version: "V6.0.5",
    date: "2024-11-22 17:32:24",
    description: "Compliance with the 24-16 MT Mode Specification V1.9. Internal Improvements.",
    md5: "7bfe1ea909f29d13932525b13e24041d",
    url: "https://drive.google.com/uc?export=download&id=100edJ2MLW7RceiI78TV91aZSyXM9vj1s",
    category: "os2_plus",
    modelTxt: "OS2 Pro MT Bootloader",
    modelKey: "os2_pro_mt_bootloader"
  },
  {
    version: "V6.0.4",
    date: "2024-10-22 10:47:32",
    description: "Compliance with the 24-16 MT Mode Specification V1.7. [SecureBoot] Do not Burn the CPU Key on Factory Mode Automatically. [SecureBoot] Add Command to Burn CPU Key. [Upgrade] Add Command to Upgrade MT-Firmware under MT-Bootloader.",
    md5: "",
    url: "https://drive.google.com/uc?export=download&id=1iEmRg1tHEBl7gMSFfgvFZqDqbD_TuDL4",
    category: "os2_plus",
    modelTxt: "OS2 Pro MT Bootloader",
    modelKey: "os2_pro_mt_bootloader"
  }
]

// Static data for OS5 MT firmware and OS2 Pro MT firmware
const staticFirmwareData = [
  // --- OS5 MT Firmware ---
  {
    version: "V5.01.0007",
    date: "2025/06/04 08:30:21",
    description: `Compliance with the OS5 MT Mode Specification V1.5.\nPoE Test Issue: add the PoE port enable command (1225)`,
    md5: "7da5dd93c97f29315d45568c725f2855",
    url: "https://drive.google.com/uc?export=download&id=1zS9tqwchp5v4W4W5In2vmyyjoHUedJ20",
    category: "os5",
    modelTxt: "OS5 MT Firmware",
    modelKey: "os5_mt_firmware"
  },
  {
    version: "V5.01.0006",
    date: "2025/04/08 12:12:07",
    description: `[RollbackToMT] Upgrade Bootloader to mtb_V5.0.1 when rollback from PT to MT\n[appdemo] appdemo support model IPGS-H7408XF\n[appdemo] appdemo support model TPGS-H7508XTR` ,
    md5: "6dc43d8ec7a118df121eb83a1668ba2d",
    url: "https://drive.google.com/uc?export=download&id=1_kQirFFiwTcy3xxOm0al20MlUW_3eaev",
    category: "os5",
    modelTxt: "OS5 MT Firmware",
    modelKey: "os5_mt_firmware"
  },
  {
    version: "V5.01.0005",
    date: "2025/03/14 02:36:55",
    description: `New Models: IPGS-H7408XF, TPGS-H7508XTR` ,
    md5: "f9c8056692f1d7b264c95e503031bf73",
    url: "https://drive.google.com/uc?export=download&id=1DAu1ED0x1n_5CmaE4Cs42zJMMbRGrQ7x",
    category: "os5",
    modelTxt: "OS5 MT Firmware",
    modelKey: "os5_mt_firmware"
  },
  {
    version: "V5.01.0004",
    date: "2025/02/07 05:40:30",
    description: `Compliance with the OS5 MT Mode Specification V1.3\nCorrect the Help Text for Configuring Port Speed\nNew Models: T(P)GS-H7624XT/XFT Series, I(P)GS-H7416XF Series, I(P)GS-H7624XF Series, T(P)GS-H7808XT Series` ,
    md5: "2d6ad8f21318165636ed5fdd97a10f57",
    url: "https://drive.google.com/uc?export=download&id=1lAVaPyoMFDATgk0HL78z44XbkTtQzYJf",
    category: "os5",
    modelTxt: "OS5 MT Firmware",
    modelKey: "os5_mt_firmware"
  },
  {
    version: "V5.01.0003",
    date: "2025/01/22 10:30:43",
    description: `Compliance with the OS5 MT Mode Specification V1.2\nNew Models: T(P)GS-H7624XT/XFT Series, I(P)GS-H7416XF Series, I(P)GS-H7624XF Series, T(P)GS-H7808XT Series\nRollback to MT needs to collaborate with PT-Bootloader V5.0.5 (Secure) or V5.1.5 (None-Secure)\nMigrate to PT needs to collaborate with PT-Firmware V5.01.0007 (Secure) or V5.01.0007 (None-Secure)` ,
    md5: "faabd02d99b69562924c3c0831aadf97",
    url: "https://drive.google.com/uc?export=download&id=1ODv5c1UVEKDaJA8P9TvBwrJysZcfqueg",
    category: "os5",
    modelTxt: "OS5 MT Firmware",
    modelKey: "os5_mt_firmware"
  },
  // --- OS2 Pro MT Firmware ---
  {
    version: "V6.01.0009",
    date: "2025-06-04 08:59:46",
    description: `eMMC Test Issue: Does not start eMMC testing properly (1258)` ,
    md5: "322635c4bedd68fa19bed0dd63ba7eac",
    url: "https://drive.google.com/uc?export=download&id=1r0rX-Y6tKja1MFAE6bsdUDMNUddrWesG",
    category: "os2_plus",
    modelTxt: "OS2 Pro MT Firmware",
    modelKey: "os2_pro_mt_firmware"
  },
  {
    version: "V6.01.0006",
    date: "2024-12-18 12:36:55",
    description: `New Models: TPGS-3208MGT, TES-3406T` ,
    md5: "d26562bd91aa6f9822344fa0001cdd7a",
    url: "https://drive.google.com/uc?export=download&id=1Yt0BO0OANRu2ZgXGavp2dg0dNdC7g1kl",
    category: "os2_plus",
    modelTxt: "OS2 Pro MT Firmware",
    modelKey: "os2_pro_mt_firmware"
  },
  {
    version: "V6.01.0005",
    date: "2024-11-25 09:16:27",
    description: `Compliance with the 24-16 MT Mode Specification V1.9.\nBootloader Issue: Resolved corruption when upgrading from MT mode to PT mode. (#1031)\nVersion Issue: Fixed incorrect version number display. (#1034)` ,
    md5: "88f85fa42ac665b941fd58b87d9897f9",
    url: "https://drive.google.com/uc?export=download&id=1oLpN8yzqhqqMCq5szy9yWXmuBbxuczrf",
    category: "os2_plus",
    modelTxt: "OS2 Pro MT Firmware",
    modelKey: "os2_pro_mt_firmware"
  },
  {
    version: "V6.01.0003",
    date: "",
    description: `Compliance with the 24-16 MT Mode Specification V1.7\nSupport Models: TPGR-3208T (New in this version), TPER-3208T (New in this version), TPGR-3208GF\nFix: [Switch] MAC Table Dump always Returns Empty, [Hardware] System Freezes when the PoE Controller fails to respond to Commands` ,
    md5: "",
    url: "https://drive.google.com/uc?export=download&id=1fvCRg7Z6hlERxagFfi6JzrAxurgacw6d",
    category: "os2_plus",
    modelTxt: "OS2 Pro MT Firmware",
    modelKey: "os2_pro_mt_firmware"
  }
]

export default {
  name: 'FirmwareDownload',
  components: {
    'v-select': select,
    spinner
  },
  vuex: {
    getters: {
      user: state => state.user
    }
  },
  data () {
    return {
      selectedCategory: 'any', // default to 'any'
      selectedModel: 'any',    // default to 'any'
      selectedBootloader: null,
      selectedFirmware: null,
      showWarning: false,
      firmwareData: staticFirmwareData,
      isLoading: false,
      categoryOptions: [
        { label: 'Any', value: 'any' },
        { label: 'OS2 Pro', value: 'os2_plus' },
        { label: 'OS5', value: 'os5' }
      ],
      modelOptions: [
        { label: 'Any', value: 'any' }
      ],
      bootloaderOptions: [
        { label: 'Any', value: 'any' }
      ],
      firmwareOptions: [
        { label: 'Any', value: 'any' }
      ],
      allProductModels: [], // will hold product/device data with .key
      selectedModelCategory: 'any',
    }
  },
  computed: {
    filteredData () {
      let filtered = this.firmwareData

      // Filter by category
      if (this.selectedCategory !== 'any') {
        filtered = filtered.filter(item => item.category === this.selectedCategory)
      }

      // Filter by model
      if (this.selectedModel !== 'any') {
        filtered = filtered.filter(item => item.modelKey === this.selectedModel)
      }

      // Filter by bootloader
      if (this.selectedBootloader !== 'any') {
        filtered = filtered.filter(item =>
          item.modelTxt.toLowerCase().includes('bootloader') &&
          item.version === this.selectedBootloader
        )
      }

      // Filter by firmware
      if (this.selectedFirmware !== 'any') {
        filtered = filtered.filter(item =>
          !item.modelTxt.toLowerCase().includes('bootloader') &&
          item.version === this.selectedFirmware
        )
      }

      return filtered
    }
  },
  methods: {
    getCustomForUI,
    getIconSrc,
    fetchModels () {
      this.isLoading = true
      getDb().ref('product').once('value', sn => {
        const all = _.transform(sn.val(), (result, value, key) => {
          result.push({ '.key': key, ...value })
        }, [])
        // Only os2_plus (os2pro) and os5
        this.allProductModels = all.filter(m => m.category === 'os2_plus' || m.category === 'os5')
        this.updateModelOptions()
        this.isLoading = false
      })
    },
    onCategoryChange () {
      this.selectedModel = 'any'
      this.selectedBootloader = null
      this.selectedFirmware = null
      this.updateModelOptions()
      this.updateBootloaderOptions()
      this.updateFirmwareOptions()
    },
    onModelChange () {
      // Find the selected model in allProductModels and set its category
      const found = this.allProductModels.find(m => m['.key'] === this.selectedModel);
      console.log('found', found);
      const newCategory = found ? found.category : 'any';
      this.selectedModelCategory = newCategory;
      // this.selectedCategory = newCategory; // <-- This line ensures the UI and logic are in sync
      this.selectedBootloader = null;
      this.selectedFirmware = null;
      this.updateModelOptions();
      this.updateBootloaderOptions();
      this.updateFirmwareOptions();
    },
    updateModelOptions () {
      let models = ['any'];
      // Always filter to only os2pro and os5 models
      let filtered = this.allProductModels.filter(
        item => item.category === 'os2_plus' || item.category === 'os5'
      );
      if (this.selectedCategory !== 'any') {
        filtered = filtered.filter(item => item.category === this.selectedCategory);
      }
      const uniqueKeys = _.uniq(filtered.map(item => item['.key']));
      models = ['any', ...uniqueKeys];
      this.modelOptions = models.map(model => ({ label: model === 'any' ? 'Any' : model, value: model }));
    },
    updateBootloaderOptions () {
      const filterCategory = this.selectedModel !== 'any' ? this.selectedModelCategory : this.selectedCategory;
      let filteredData = staticBootloaderData.filter(item =>
        (filterCategory === 'any' || item.category === filterCategory)
      );
      console.log('filterCategory', filterCategory);
      console.log('filteredData', filteredData);
      const realVersions = filteredData.map(item => item.version);
      if (realVersions.length === 0) {
        this.bootloaderOptions = [];
        this.selectedBootloader = null;
      } else {
        this.bootloaderOptions = realVersions.map(version => ({ label: version, value: version }));
        if ((this.selectedCategory !== 'any' || this.selectedModel !== 'any') && this.bootloaderOptions.length > 0) {
          this.selectedBootloader = this.bootloaderOptions[0].value;
        } else if (!this.bootloaderOptions.find(opt => opt.value === this.selectedBootloader)) {
          this.selectedBootloader = null;
        }
      }
    },
    updateFirmwareOptions () {
      const filterCategory = this.selectedModel !== 'any' ? this.selectedModelCategory : this.selectedCategory;
      let filteredData = staticFirmwareData.filter(item =>
        (filterCategory === 'any' || item.category === filterCategory)
      );
      const realVersions = filteredData.map(item => item.version);
      if (realVersions.length === 0) {
        this.firmwareOptions = [];
        this.selectedFirmware = null;
      } else {
        this.firmwareOptions = realVersions.map(version => ({ label: version, value: version }));
        if ((this.selectedCategory !== 'any' || this.selectedModel !== 'any') && this.firmwareOptions.length > 0) {
          this.selectedFirmware = this.firmwareOptions[0].value;
        } else if (!this.firmwareOptions.find(opt => opt.value === this.selectedFirmware)) {
          this.selectedFirmware = null;
        }
      }
    },
        downloadBootloader () {
      if (this.selectedBootloader !== 'any') {
        const bootloader = staticBootloaderData.find(item =>
          item.modelTxt.toLowerCase().includes('bootloader') &&
          item.version === this.selectedBootloader
        )
        if (bootloader && bootloader.url) {
          this.handleDownload(bootloader.url)
        } else {
          console.warn('No bootloader found for selected version')
        }
      }
    },
    downloadFirmware () {
      if (this.selectedFirmware !== 'any') {
        const firmware = staticFirmwareData.find(item =>
          !item.modelTxt.toLowerCase().includes('bootloader') &&
          item.version === this.selectedFirmware
        )
        if (firmware && firmware.url) {
          this.handleDownload(firmware.url)
        } else {
          console.warn('No firmware found for selected version')
        }
      }
    },
    handleDownload (url, event) {
      if (event) {
        event.preventDefault()
      }
      if (url) {
        try {
          window.open(url, '_blank')
        } catch (error) {
          console.error('Download failed:', error)
          // You could add a user notification here
        }
      }
    }
  },
  ready () {
    getDb().ref('product').once('value', sn => {
      this.allProductModels = _.transform(sn.val(), (result, value, key) => {
        result.push({ '.key': key, ...value })
      }, []);
      this.updateModelOptions();
      this.updateBootloaderOptions();
      this.updateFirmwareOptions();
    });
  }
}
</script>

<style lang="scss" scoped>
.function_bar {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f8f9fa;
  border-radius: 5px;
}

.form-group {
  margin-bottom: 15px;
}

.control_label {
  font-weight: bold;
  margin-bottom: 5px;
  display: block;
}

.device_icon {
  width: 30px;
  height: 30px;
  display: inline-block;
  margin-right: 10px;

  img {
    width: 30px;
    height: 30px;
  }
}

.alert {
  margin-top: 20px;
}

.panel {
  margin-top: 20px;
}

.table {
  margin-bottom: 0;
}

.btn-group {
  .btn {
    margin-right: 5px;
  }
}

.badge {
  color: white;
  padding: 5px 10px;
  border-radius: 3px;
}

::v-deep .dropdown-menu {
  width: 100% !important;
  min-width: 100% !important;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// FirmwareDownload.vue?eca5575e